import React, { useEffect, useState } from 'react';
import { apiCall } from '../../utils/apiService';

const MessageHeaderLayer = ({ getHeaderData }) => {
    const [instances, setInstances] = useState([]);
    const [apiKey, setApiKey] = useState(() => localStorage.getItem('apiKey') || '');
    const [selectedClient, setSelectedClient] = useState('');

    const fetchInstances = async () => {
        try {
            const response = await apiCall({
                url: `sessions/get-users-instances`,
                method: 'GET',
            });
            setInstances(response.data);
        } catch (error) {
            console.error('Error fetching instances:', error);
        }
    };

    useEffect(() => {
        fetchInstances();
        const k = localStorage.getItem('apiKey') || '';
        setApiKey(k);
        if (typeof getHeaderData === 'function') {
            getHeaderData('', k);
        }
    }, []);

    return (
        <>
            <div
                className="row g-0 p-3"
                style={{
                    border: '1px solid #4CAF50',
                    background: '#E8F5E9',
                    borderRadius: '5px',
                }}
            >
                <div className="col-sm-6 my-2 pe-md-3">
                    <div className="form-group">
                        <select
                            name="instance"
                            id="msg-header-instance"
                            className="form-select bg-white"
                            value={selectedClient}
                            onChange={(e) => {
                                const v = e.target.value;
                                setSelectedClient(v);
                                getHeaderData(v, apiKey);
                            }}
                        >
                            <option value="" disabled>
                                Select Instance
                            </option>
                            {instances.length > 0 &&
                                instances.map((instance) => (
                                    <option key={instance.client_id} value={instance.client_id}>
                                        {instance.name}
                                    </option>
                                ))}
                        </select>
                    </div>
                </div>
                <div className="col-sm-6 my-2 ps-md-3">
                    <div className="form-group">
                        <input
                            type="text"
                            className="form-control bg-white"
                            placeholder="Your Token"
                            value={apiKey}
                            onChange={(e) => {
                                const v = e.target.value;
                                setApiKey(v);
                                getHeaderData(selectedClient, v);
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default MessageHeaderLayer;
